import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Route, Switch, Router } from 'react-router-dom'
import { launchInit } from '../../redux/Ekko/actions'
import { changeRoute } from '../../redux/Settings/actions'
import history from '../../util/history'

import { LAYOUT_TYPE_BOXED, LAYOUT_TYPE_FRAMED, LAYOUT_TYPE_FULL } from 'redux/Settings/constants'
import Routes from './Routes'
import OnboardingRoutes from './OnboardingRoutes'

class Root extends React.Component {
    setLayoutType = layoutType => {
        if (layoutType === LAYOUT_TYPE_FULL) {
            document.body.classList.remove('boxed-layout')
            document.body.classList.remove('framed-layout')
            document.body.classList.add('full-layout')
        } else if (layoutType === LAYOUT_TYPE_BOXED) {
            document.body.classList.remove('full-layout')
            document.body.classList.remove('framed-layout')
            document.body.classList.add('boxed-layout')
        } else if (layoutType === LAYOUT_TYPE_FRAMED) {
            document.body.classList.remove('boxed-layout')
            document.body.classList.remove('full-layout')
            document.body.classList.add('framed-layout')
        }
    }

    componentDidMount() {
        const { launchInit } = this.props

        // launchInit()
    }

    render() {
        const { layoutType } = this.props
        this.setLayoutType(layoutType)
        return (
            <Router history={history}>
                <Switch>
                    <Route path="/now" component={OnboardingRoutes} />
                    <Route path="/" component={Routes} />
                </Switch>
                {/* <Routes /> */}
            </Router>
        )
    }
}

const mapStateToProps = ({ settings }) => {
    const { layoutType } = settings
    return { layoutType }
}

const mapActionsToProps = dispatch => ({
    launchInit: bindActionCreators(launchInit, dispatch),
    changeRoute: bindActionCreators(changeRoute, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(Root)
